<template>
    <v-app id="backGND">
        <navBar />
        
        <h1 style=" margin-top: 0.5em; margin-left: 35%; width: 35%;">Administrador de usuarios</h1>

        <!--******************* Buscador de usuarios ********************* -->
        <div style="margin-top: 1em; width: 80%; margin-left: 10%; display: inline-block; vertical-align: center;">
            
            <h4> Buscar usuario </h4>
            <div style="width: 25%; display: inline-block; vertical-align: center;">
                <span><p>Apellido:</p></span>
                <input class="register-modal" placeholder="EJ. PERÉZ" v-model="search_user_lastName">
            </div>
            <div style="width: 25%; display: inline-block; vertical-align: center;">
                <v-btn
                style="
                    width: 5%;
                    background-color: #2196F3;
                "
                @click="searchUser()"
                ><v-icon style="color: white;">mdi-account-search-outline</v-icon></v-btn>
            </div>

            <div style="width: 25%; display: inline-block; vertical-align: center;">
                <v-btn
                style="
                    width: 5%;
                    background-color: #2196F3;
                "
                @click="array_regeristeredAt = []; getData(toTimestamp('01/01/2021 12:13:29'),1)"
                ><v-icon style="color: white;">mdi-refresh</v-icon></v-btn>
            </div>
            <br/>
            <div style="width: 25%; display: inline-block; vertical-align: center;">
                <b><span style="color:balck"><p>Correo Electronico:</p></span></b>
                <input class="register-modal" placeholder="EJ. barreprodgo@gmail.com" v-model="search_user_email">
            </div>
            <div style="width: 25%; display: inline-block; vertical-align: center;">
                <v-btn
                style="
                    width: 5%;
                    background-color: #2196F3;
                "
                @click="searchUserEmail()"
                ><v-icon style="color: white;">mdi-account-search-outline</v-icon></v-btn>
            </div>

            <div style="width: 25%; display: inline-block; vertical-align: center;">
                <v-btn
                style="
                    width: 5%;
                    background-color: #2196F3;
                "
                @click="array_regeristeredAt = []; getData(toTimestamp('01/01/2021 12:13:29'),1)"
                ><v-icon style="color: white;">mdi-refresh</v-icon></v-btn>
            </div>

        </div>

        <div v-if="show_spinner_search" class="text-center">  
            <v-progress-circular
                indeterminate
                :rotate="-90"
                :size="50"
                :width="5"
                color=#2E7D32
                >
            </v-progress-circular>    
        </div>

        <span class="error_message"><p>{{ error_search_user }}</p></span>
        <span class="success_message"><p>{{success_search_user}}</p></span>

        <v-btn
            style="
                margin-top: 1.5em;
                margin-bottom: .5em;
                width: 5%;
                margin-left: 80%;
                background-color: #2196F3;
            "
            @click="showAddModal()"
        ><v-icon style="color: white;">mdi-plus</v-icon></v-btn>

        <v-simple-table
            fixed-header height="500px"
            style="margin-left: 10%; width: 80%; overflow-y: scroll;">
            <template v-slot:default>
            <thead>
                <tr>
                <th style="font-size: 1em; text-align: center;">Nombres</th>
                <th style="font-size: 1em; text-align: center;">Apellidos</th>
                <th style="font-size: 1em; text-align: center;">Teléfono</th>
                <th style="font-size: 1em; text-align: center;">Correo</th>
                <th style="font-size: 1em; text-align: center;">Suscripción</th>
                <th style="font-size: 1em; text-align: center;">Periodo de suscripción</th>
                <th style="font-size: 1em; text-align: center;"></th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="(u,index) in users" v-bind:key="index">
                <td style="text-align: center;">{{ u.name }}</td>
                <td style="text-align: center;">{{ u.lastName }}</td>
                <td style="text-align: center;">{{ u.phone }}</td>
                <td style="text-align: center;">{{ u.email }}</td>
                <td style="text-align: center;">{{ u.package_name }}</td>
                <td style="text-align: center;">{{ u.suscription_date }}</td>
                <td style="text-align: right;">
                  <v-list-item-icon >
                    <v-icon style="color: #2196F3;" @click="seeUserPackages(index)">mdi-book-open-variant</v-icon>
                    <v-icon style="margin-left: .4em; margin-right: .4em; color: green;" @click="showEditModal(index)">mdi-border-color</v-icon>
                    <v-icon style="color: red;" @click="showDeleteModal(index)">mdi-delete</v-icon>
                  </v-list-item-icon>
                </td>
                </tr>
            </tbody>
            </template>
        </v-simple-table>

        <div style="margin-bottom: 1.5em; margin-top: 1.5em; margin-left: 25%; display: inline-block; width: 50%">
            <div style="width: 20%;
                        display: inline-block;">
                <v-btn
                style="
                    background-color: #2196F3;
                "
                @click="changePage( page - 1,'rest')"
                ><v-icon style="color: white;">mdi-chevron-left</v-icon></v-btn>
            </div>
            
            <div style="width: 9%; display: inline-block;">
                <span>{{page}}</span>
            </div>

            <div style="width: 20%;
                        display: inline-block;">
                <v-btn
                style="
                    background-color: #2196F3;
                "
                @click="changePage( page + 1,'add')"
                ><v-icon style="color: white;">mdi-chevron-right</v-icon></v-btn>
            </div>
        </div>

        <div class="text-center">
            <v-dialog v-model="dialog" width="1100" :retain-focus="false">
                <v-card max-width="1100" class="mx-auto">
                    <v-toolbar color="#060d0e" dark>
                        <v-toolbar-title>AGREGAR USUARIOS</v-toolbar-title>
                    </v-toolbar>

                    <v-simple-table v-model="rows">
                        <template v-slot:default>
                            <thead>
                                <tr>
                                  <th style="font-size: 1em; text-align: center;">Nombre</th>
                                  <th style="font-size: 1em; text-align: center;">Apellido</th>
                                  <th style="font-size: 1em; text-align: center;">Correo</th>
                                  <th style="font-size: 1em; text-align: center;">Paquete</th>
                                  <th></th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(row, i) in rows" :key="i">
                                    <td>
                                        <input class="register-modal" type="text" :ref="'table_ref'" placeholder="EJ. JUAN" v-model="row.name">
                                    </td>
                                    <td>
                                        <input class="register-modal" placeholder="EJ. PERÉZ" v-model="row.lastName">
                                    </td>
                                    <td>
                                        <input class="register-modal" placeholder="EJ. barrepro@gmail.com" v-model="row.email">
                                    </td>
                                    <td>
                                        <select v-model="row.package" v-on:keydown.tab="addRow(i)">
                                            <option value="*">Selecciona un paquete</option>
                                            <option value="Prueba gratis de 7 días">Prueba gratis de 7 días</option>
                                            <option value="Mensual">Mensual $420</option>
                                            <option value="Bimestral">Bimestral $700</option>
                                        </select>
                                    </td>
                                    <td>
                                        <a v-on:click="removeRow(i)" style="color: #dc3545 !important; cursor: pointer;">
                                            <v-icon style="color: red;">mdi-close-thick</v-icon>
                                        </a>
                                    </td>
                                </tr>
                            </tbody>
                            <a v-on:click="addRow(count_index)" style="margin-left: -10em; cursor: pointer;">
                                <v-icon style="color: #007bff !important;">mdi-plus</v-icon>
                            </a>
                        </template>
                    </v-simple-table>

                    <v-divider></v-divider>
                    <v-card-actions>
                        <v-btn
                            style="
                                margin-right: 30%;
                                margin-left: 30%;
                                width: 5%;
                                background-color: rgba(36, 163, 91, 1);
                            "
                            @click="saveUsers()"
                        ><v-icon style="color: white;">mdi-content-save</v-icon></v-btn>

                        <v-btn
                            style="
                                width: 5%;
                                background-color: rgba(227, 22, 22, 1);
                            "
                            @click="dialog = false"
                        ><v-icon style="color: white;">mdi-close-thick</v-icon></v-btn>
                    </v-card-actions>
                    <span class="error_message"><p v-html="error_form"></p></span>
                    <span class="success_message"><p v-html="success_form"></p></span>
                    <!-- barra de progreso, mientras carga el proceso -->
                    <div v-if="show_spinner" class="text-center">  
                            <v-progress-circular
                                indeterminate
                                :rotate="-90"
                                :size="50"
                                :width="5"
                                color=#2E7D32
                            >
                            </v-progress-circular>    
                    </div>
                </v-card>
            </v-dialog>
        </div>

        <!-- ************* EDIT MODAL ***************-->

        <div class="text-center">
            <v-dialog v-model="dialog_edit" width="1100" :retain-focus="false">
                <v-card max-width="1100" class="mx-auto">
                    <v-toolbar color="#060d0e" dark>
                        <v-toolbar-title>EDITAR USUARIO</v-toolbar-title>
                    </v-toolbar>

                    <div style="margin-top: 1em;">
                        <span style="font-size: 1.2em; font-weight: 600;"><p> Nombres: </p></span>
                        <input class="register-modal" placeholder="EJ. JUAN" v-model="name">
                        <span class="error_message"><p>{{ error_name }}</p></span>
                    </div>

                    <div style="margin-top: 1em;">
                        <span style="font-size: 1.2em; font-weight: 600;"><p> Apellidos: </p></span>
                        <input class="register-modal" placeholder="EJ. PERÉZ" v-model="lastName">
                        <span class="error_message"><p>{{ error_lastName }}</p></span>
                    </div>

                    <v-divider></v-divider>
                    <v-card-actions>
                        <v-btn
                            style="
                                margin-right: 30%;
                                margin-left: 30%;
                                width: 5%;
                                background-color: rgba(36, 163, 91, 1);
                            "
                            @click="editUsers()"
                        ><v-icon style="color: white;">mdi-content-save</v-icon></v-btn>

                        <v-btn
                            style="
                                width: 5%;
                                background-color: rgba(227, 22, 22, 1);
                            "
                            @click="dialog_edit = false"
                        ><v-icon style="color: white;">mdi-close-thick</v-icon></v-btn>
                    </v-card-actions>

                    <div>
                        <span class="error_message"><p>{{ error_edit_form }}</p></span>
                        <span class="success_message"><p>{{success_edit_form}}</p></span>
                    </div>

                    <!-- barra de progreso, mientras carga el proceso -->
                    <div v-if="show_spinner_edit" class="text-center">  
                            <v-progress-circular
                                indeterminate
                                :rotate="-90"
                                :size="50"
                                :width="5"
                                color=#2E7D32
                            >
                            </v-progress-circular>    
                    </div>

                </v-card>
            </v-dialog>
        </div>

        <!-- ************ DELETE MODAL **************-->

        <div class="text-center">
            <v-dialog v-model="dialog_delete" width="1100" :retain-focus="false">
                <v-card max-width="1100" class="mx-auto">
                    <v-toolbar color="#060d0e" dark>
                        <v-toolbar-title>ELIMINAR USUARIO</v-toolbar-title>
                    </v-toolbar>

                    <div style="margin-top: 1em;">
                        <span style="font-size: 1.2em; font-weight: 600;"><p>¿Estas seguro de eliminar al usuario: {{name_delete}} ?</p></span>
                    </div>

                    <v-divider></v-divider>
                    <v-card-actions>
                        <v-btn
                            style="
                                margin-right: 30%;
                                margin-left: 30%;
                                width: 5%;
                                background-color: rgba(36, 163, 91, 1);
                            "
                            @click="deleteUsers()"
                        ><v-icon style="color: white;">mdi-content-save</v-icon></v-btn>

                        <v-btn
                            style="
                                width: 5%;
                                background-color: rgba(227, 22, 22, 1);
                            "
                            @click="dialog_delete = false"
                        ><v-icon style="color: white;">mdi-close-thick</v-icon></v-btn>
                    </v-card-actions>

                    <div>
                        <span class="error_message"><p>{{ error_delete_form }}</p></span>
                        <span class="success_message"><p>{{success_delete_form}}</p></span>
                    </div>

                    <!-- barra de progreso, mientras carga el proceso -->
                    <div v-if="show_spinner_delete" class="text-center">  
                            <v-progress-circular
                                indeterminate
                                :rotate="-90"
                                :size="50"
                                :width="5"
                                color=#2E7D32
                            >
                            </v-progress-circular>    
                    </div>

                </v-card>
            </v-dialog>
        </div>

        <!-- ************ SEE MODAL **************-->

        <div class="text-center">
            <v-dialog v-model="dialog_see" width="1100" :retain-focus="false">
                <v-card max-width="1100" class="mx-auto">
                    <v-toolbar color="#060d0e" dark>
                        <v-toolbar-title>SUSCRIPCIONES DEL USUARIO</v-toolbar-title>
                    </v-toolbar>

                    <div v-if="see_packages.length>0">

                        <h4 style="margin-top: 1em;">SUSCRIPCIONES RECIENTES DE: {{package_user_name}}</h4>

                        <v-simple-table v-if="see_packages.length>0" v-model="see_packages">
                            <template v-slot:default>
                                <thead>
                                    <tr>
                                    <th style="font-size: 1em; text-align: center;">Paquete</th>
                                    <th style="font-size: 1em; text-align: center;">Precio</th>
                                    <th style="font-size: 1em; text-align: center;">Periodo de suscripción</th>
                                    <th></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(p, i) in see_packages" :key="i">
                                        <td>
                                            <span>{{p.name}}</span>
                                        </td>
                                        <td>
                                            <span>{{p.price}}</span>
                                        </td>
                                        <td>
                                            <span>{{p.suscription_date}}</span>
                                        </td>
                                        <td>
                                            <v-icon v-if="i==see_packages.length-1" style="color: green;" @click="editPackage()">mdi-border-color</v-icon>
                                        </td>
                                    </tr>
                                </tbody>
                            </template>
                        </v-simple-table>
                    </div>

                    <v-btn
                        style="
                            margin-top: 1.5em;
                            margin-bottom: .5em;
                            width: 5%;
                            margin-left: 80%;
                            background-color: #2196F3;
                        "
                        @click="show_package = true; edit_package = false; select_package='*'"
                    ><v-icon style="color: white;">mdi-plus</v-icon></v-btn>

                    <div v-if="show_package">
                        <h4 v-if="edit_package" style="margin-top: 1em;">EDITAR PAQUETE</h4>
                        <h4 v-else style="margin-top: 1em;">AGREGAR PAQUETE</h4>
                        <select v-model="select_package">
                            <option value="*">Selecciona un paquete</option>
                            <option value="Prueba gratis de 7 días">Prueba gratis de 7 días</option>
                            <option value="Mensual">Mensual $420</option>
                            <option value="Bimestral">Bimestral $700</option>
                            <option value="Trimestral">Trimestral $1090</option>
                            <option value="6Meses">6 Meses $2090</option>
                        </select>
                        <a v-on:click="edit_package=false; show_package=false; select_package='*'" style="color: #dc3545 !important; cursor: pointer;">
                            <v-icon style="color: red;">mdi-close-thick</v-icon>
                        </a>
                    </div>

                    <v-divider></v-divider>
                    <v-card-actions>
                        <v-btn v-if="show_package"
                            style="
                                margin-right: 30%;
                                margin-left: 30%;
                                width: 5%;
                                background-color: rgba(36, 163, 91, 1);
                            "
                            @click="addPackageToUsers()"
                        ><v-icon style="color: white;">mdi-content-save</v-icon></v-btn>

                        <v-btn
                            style="
                                width: 5%;
                                background-color: rgba(227, 22, 22, 1);
                            "
                            @click="dialog_see = false;"
                        ><v-icon style="color: white;">mdi-close-thick</v-icon></v-btn>
                    </v-card-actions>

                    <div>
                        <span class="error_message"><p>{{ error_see_form }}</p></span>
                        <span class="success_message"><p>{{success_see_form}}</p></span>
                    </div>

                    <!-- barra de progreso, mientras carga el proceso -->
                    <div v-if="show_spinner_see" class="text-center">  
                            <v-progress-circular
                                indeterminate
                                :rotate="-90"
                                :size="50"
                                :width="5"
                                color=#2E7D32
                            >
                            </v-progress-circular>    
                    </div>

                </v-card>
            </v-dialog>
        </div>
    </v-app>
</template>

<script>
import navBar from "@/components/navbar";
import { db } from "@/main";
import firebase from "firebase";
import * as faker from "faker";

export default {
  components: { navBar },
  data(){
      return {
        rows: [ {name: "", lastName: "", email: "", package: "*"} ],
        count_index: 0,
        users: [],
		page: 1,
        dialog: false,
        show_spinner: false,
        error_form: "",
        success_form: "",
        dialog_edit: false,
        name: "",
        lastName: "",
        email: "",
        uid: "",
        error_edit_form: "",
        success_edit_form: "",
        error_name: "",
        error_lastName: "",
        show_spinner_edit: false,
        dialog_delete: false,
        error_delete_form: "",
        name_delete: "",
        uid_delete: "",
        success_delete_form: "",
        show_spinner_delete: "",
        error_see_form: "",
        success_see_form: "",
        show_spinner_see: false,
        see_packages: [],
        package_name: "",
        uid_see: "",
        dialog_see: false,
        show_package: false,
        select_package: "*",
        edit_package: false,
        position_user: 0,
        package_user_name: "",
        search_user_lastName: "",
        search_user_email: "",
        error_search_user: "",
        success_search_user: "",
        show_spinner_search: false,
        array_regeristeredAt: []
      };
  },
  methods: {
    saveUsers: async function(){
        var flag = true
        this.error_form = ""
        this.success_form = ""
        var error_form = ""
        var success_form = ""
        this.show_spinner = true
        var success = []

        for (var i = 0; i < this.rows.length; i++) {
            if((this.rows[i].name == "")||(this.rows[i].lastName == "")||(this.rows[i].email == "")||(this.rows[i].package == "*")){
              flag = false
              this.error_form = "No puede haber campos vacíos, en la columna " + (i + 1) + "."
            }else{

              if(!(this.validEmail(this.rows[i].email))){
                flag = false
                this.error_form = "Teclear un correo válido en la columna " + (i + 1) + "."
              }
                
            }
        } 

        if(flag){

            for (var i = 0; i < this.rows.length; i++) {

                var that = this

                await firebase
                .auth()
                .createUserWithEmailAndPassword(this.rows[i].email, "Barrepro21")
                .then(async (userRegistered) => {

                    

                        var packages = []
                        var date = new Date()
                        var date_end = new Date()

                        if(this.rows[i].package == "Prueba gratis de 7 días"){

                            var p = {
                                package_name: "Prueba gratis de 7 días",
                                package_price: 0,
                                package_start: date,
                                package_end: new Date(date_end.setDate( date_end.getDate() + 7)) 
                            }

                            packages.push(p)
                        }else
                        if(this.rows[i].package == "Mensual"){

                            var p = {
                                package_name: "Mensual",
                                package_price: 420,
                                package_start: date,
                                package_end: new Date(date_end.setMonth( date_end.getMonth() + 1)) 
                            }

                            packages.push(p)
                        }else{
                            var p = {
                                package_name: "Bimestral",
                                package_price: 700,
                                package_start: date,
                                package_end: new Date(date_end.setMonth( date_end.getMonth() + 2))
                            }

                            packages.push(p)
                        }

                        var send_data = {
                            tokenKey: faker.random.alphaNumeric(10),
                            regeristeredAt: date,
                            updatedAt: date,
                            uid: userRegistered.user.uid,
                            email: userRegistered.user.email,
                            name: that.rows[i].name,
                            lastName: that.rows[i].lastName,
                            registeredBy: "email",
                            imgUrl: "",
                            role: "customer",
                            is_active: "1",
                            packages: packages,
                            //plan: "",
                            //vigency: ""
                        }

                        await db
                        .collection("users")
                        .doc(userRegistered.user.uid)
                        .get()
                        .then(async (result) => {
                            if (result.exists == false) {
                            await db
                                .collection("users")
                                .doc(userRegistered.user.uid)
                                .set(send_data)
                                .then(() => {

                                    success_form += "Usuario:" + send_data.name + " " + send_data.lastName + " creado correctamente. " + "<br>"
                                    var s = {
                                        row: i
                                    }
                                    success.push(s)
                                });
                            } else {
                                error_form += "Ocurrió un error al intentar crear al usuario: " + send_data.name + ".<br>"
                            }
                        });
                    
                })
                .catch(async (error) => {
                    console.log(error)
                    if (error.code == "auth/email-already-in-use") {

                        var bandera = false

                        await db.collection("users").where("email", "==", this.rows[i].email).where("is_active", "==", "0")
                        .get()
                        .then((querySnapshot) => {
                            querySnapshot.forEach(async (doc) => {
                                
                                if (doc.data().email == that.rows[i].email){
                                    bandera = true

                                    var packages = []
                                    var date = new Date()
                                    var date_end = new Date()

                                    if(this.rows[i].package == "Prueba gratis de 7 días"){

                                        var p = {
                                            package_name: "Prueba gratis de 7 días",
                                            package_price: 0,
                                            package_start: date,
                                            package_end: new Date(date_end.setDate( date_end.getDate() + 7)) 
                                        }

                                        packages.push(p)
                                    }else
                                    if(that.rows[i].package == "Mensual"){

                                        var p = {
                                            package_name: "Mensual",
                                            package_price: 420,
                                            package_start: date,
                                            package_end: new Date(date_end.setMonth( date_end.getMonth() + 1)) 
                                        }

                                        packages.push(p)
                                    }else{
                                        var p = {
                                            package_name: "Bimestral",
                                            package_price: 700,
                                            package_start: date,
                                            package_end: new Date(date_end.setMonth( date_end.getMonth() + 2 ))
                                        }

                                        packages.push(p)
                                    }

                                    var data = {
                                        name: that.rows[i].name,
                                        lastName: that.rows[i].lastName,
                                        is_active: "1",
                                        packages: packages
                                    }

                                    await db.collection('users').doc(doc.data().uid).set(data, { merge: true }).then(()=>{
                                        success_form += "Usuario:" + data.name + " " + data.lastName + " creado correctamente. " + "<br>"
                                    }).catch(err => {
                                        error_form += "Ocurrió un error al intentar crear el usuario: " + data.name + ", verificar <br>"
                                    })

                                }
                            })
                        })

                        if(bandera==false){
                            error_form += "El correo: " + this.rows[i].email + " ya existe, verificar <br>"
                        }

                    }
                });

            }

            if(error_form.length <= 0){
                this.success_form = "Usuario creados correctamente"
                this.rows = [{ name: '', lastName: '', email: '', package: '*' }]
                this.array_regeristeredAt = []
                this.getData(this.toTimestamp("01/01/2021 12:13:29"),1)
            }else{
                this.success_form = success_form
                this.error_form = error_form
                for (i = (success.length-1); i >= 0; i--) {
                    this.removeRow(success[i].row.toString())
                }
                this.array_regeristeredAt = []
                this.getData(this.toTimestamp("01/01/2021 12:13:29"),1)
            }

            this.show_spinner = false
        }
        this.show_spinner = false
    },
    editUsers: async function(){
        this.show_spinner_edit = true
        this.error_edit_form = ""
        this.success_edit_form = ""
        var flag = false
        var a = this.errorName()
        var b = this.errorLastName()

        if(a&&b){

            var data = {
                name: this.name,
                lastName: this.lastName
            }

            await db.collection('users').doc(this.uid).set(data, { merge: true }).then(()=>{
              flag = true
            }).catch(err => {
              flag = false;
              console.log(err)
            })

            if(flag==false){
                this.error_edit_form = "Ocurrió un error al intentar actualizar el usuaurio verificar."
            }else{
                this.array_regeristeredAt = []
                this.getData(this.toTimestamp("01/01/2021 12:13:29"),1)
                this.success_edit_form = "Usuario actualizado correctamente."
            }
        }else{
            this.error_edit_form = "Tienes un error verificar."
        }

        this.show_spinner_edit = false
        
    },
    deleteUsers: async function(){
        this.show_spinner_delete = true
        this.success_delete_form = ""
        this.error_delete_form = ""
        var flag = false

        var data = {
            is_active: "0"
        }

        await db.collection('users').doc(this.uid_delete).set(data, { merge: true }).then(()=>{
            flag = true
        }).catch(err => {
            flag = false;
            console.log(err)
        })

        if(flag==false){
            this.error_delete_form = "Ocurrió un error al intentar eliminar el usuario verificar."
        }else{
            this.array_regeristeredAt = []
            this.getData(this.toTimestamp("01/01/2021 12:13:29"),1)
            this.success_delete_form = "Usuario eliminado correctamente."
        }
        
        this.show_spinner_delete = false
    },
    addPackageToUsers: async function(){
        this.error_see_form = ""
        this.success_see_form = ""
        this.show_spinner_see = true
        
        if(this.select_package!="*"){
            var packages = []
            var date = new Date()
            var date_end = new Date()
            var last_packages_position = 0

            await db.collection('users').doc(this.uid_see).get().then(doc =>{

                if(doc.data().packages){
                    packages = doc.data().packages
                }
            })
            console.log('selected package.......', this.select_package)

            if(this.edit_package){
                last_packages_position = packages.length - 1

                if(this.select_package == "Prueba gratis de 7 días"){

                    packages[last_packages_position].package_name = "Prueba gratis de 7 días"
                    packages[last_packages_position].package_price = 0
                    packages[last_packages_position].package_start = date
                    packages[last_packages_position].package_end = new Date(date_end.setDate( date_end.getDate() + 7))

                }else
                if(this.select_package == "Mensual"){
                    packages[last_packages_position].package_name = "Mensual"
                    packages[last_packages_position].package_price = 420
                    packages[last_packages_position].package_start = date
                    packages[last_packages_position].package_end = new Date(date_end.setMonth( date_end.getMonth() + 1)) 
                }else if(this.select_package == "Bimestral"){
                    packages[last_packages_position].package_name = "Bimestral"
                    packages[last_packages_position].package_price = 700
                    packages[last_packages_position].package_start = date
                    packages[last_packages_position].package_end = new Date(date_end.setMonth( date_end.getMonth() + 2))
                }else if(this.select_package == "Trimestral"){
                    packages[last_packages_position].package_name = "Trimestral"
                    packages[last_packages_position].package_price = 1090
                    packages[last_packages_position].package_start = date
                    packages[last_packages_position].package_end = new Date(date_end.setMonth( date_end.getMonth() + 3))
                }
                else if(this.select_package == "6Meses"){
                    packages[last_packages_position].package_name = "Medio Año"
                    packages[last_packages_position].package_price = 2090
                    packages[last_packages_position].package_start = date
                    packages[last_packages_position].package_end = new Date(date_end.setMonth( date_end.getMonth() + 6))
                }

            }else{

                if(this.select_package == "Prueba gratis de 7 días"){

                    var p = {
                        package_name: "Prueba gratis de 7 días",
                        package_price: 0,
                        package_start: date,
                        package_end: new Date(date_end.setDate( date_end.getDate() + 7)) 
                    }

                    packages.push(p)

                }else
                if(this.select_package == "Mensual"){

                    var p = {
                        package_name: "Mensual",
                        package_price: 420,
                        package_start: date,
                        package_end: new Date(date_end.setMonth( date_end.getMonth() + 1)) 
                    }

                    packages.push(p)
                }else if(this.select_package == "Bimestral"){
                    var p = {
                        package_name: "Bimestral",
                        package_price: 700,
                        package_start: date,
                        package_end: new Date(date_end.setMonth( date_end.getMonth() + 2 ))
                    }

                    packages.push(p)
                }else if(this.select_package == "Trimestral"){
                    var p = {
                        package_name: "Trimestral",
                        package_price: 1090,
                        package_start: date,
                        package_end: new Date(date_end.setMonth( date_end.getMonth() + 3 ))
                    }

                    packages.push(p)
                }else if(this.select_package == "6Meses"){
                    var p = {
                        package_name: "Medio Año",
                        package_price: 2090,
                        package_start: date,
                        package_end: new Date(date_end.setMonth( date_end.getMonth() + 6 ))
                    }

                    packages.push(p)
                }
            }

            var data = {
                packages: packages
            }

            var that = this

            await db.collection('users').doc(this.uid_see).set(data, { merge: true }).then(()=>{
                if(that.edit_package){
                    that.success_see_form = "Paquete editado correctamente"
                }else{
                    that.success_see_form = "Paquete agregado correctamente"
                }
                that.edit_package = false
                that.show_package = false
                that.select_package = '*'
                that.refreshUserPackages(that.position_user)
                that.array_regeristeredAt = []
                that.getData(this.toTimestamp("01/01/2021 12:13:29"),1)
            }).catch(err => {
                that.error_see_form = "Ocurrió un error al intentar realizar los cambios, verificar"
                console.log(err)
            })

        }else{
            this.error_see_form = "Selecciona un paquete por favor."
        }

        this.show_spinner_see = false
    },
    searchUser: async function(){
        this.page = 1
        this.show_spinner_search = true
        this.success_search_user = ""
        this.error_search_user = ""

        if(this.search_user_lastName!=""){

            await db.collection('users').where("role", "==", "customer").where("is_active", "==", "1").orderBy('lastName').startAt(this.search_user_lastName).endAt(this.search_user_lastName+'\uf8ff')
            .get()
            .then((querySnapshot) => {

                if(querySnapshot.empty==false){
                    this.users = []
                
                    querySnapshot.forEach((doc) => {

                        var package_name = ""
                        var suscription_date = ""

                        if(doc.data().packages){
                            var last_packages_position = doc.data().packages.length

                            package_name = doc.data().packages[last_packages_position -1].package_name
                            var start = doc.data().packages[last_packages_position -1].package_start.toDate()
                            var end = doc.data().packages[last_packages_position -1].package_end.toDate()
                            
                            var day = "0" +start.getDate()
                            var month = "0" + (start.getMonth()+1)
                            var year = start.getFullYear()
                            var hours = start.getHours()
                            var minutes = "0" + start.getMinutes()
                            var seconds = "0" + start.getSeconds()

                            var package_start = day.substr(-2) + "-" + month.substr(-2) + "-" + year + " " + hours + ':' + minutes.substr(-2) + ':' + seconds.substr(-2);

                            day = "0" +end.getDate()
                            month = "0" + (end.getMonth()+1)
                            year = end.getFullYear()
                            hours = end.getHours()
                            minutes = "0" + end.getMinutes()
                            seconds = "0" + end.getSeconds()

                            var package_end = day.substr(-2) + "-" + month.substr(-2) + "-" + year + " " + hours + ':' + minutes.substr(-2) + ':' + seconds.substr(-2);
                            
                            suscription_date = "Del: " + package_start + " hasta: " + package_end
                        }

                        var u = {
                            uid: doc.data().uid,
                            name: doc.data().name,
                            lastName: doc.data().lastName,
                            email: doc.data().email,
                            package_name: package_name,
                            suscription_date: suscription_date,
                            regeristeredAt: doc.data().regeristeredAt,
                            phone: doc.data().phone
                        }

                        this.users.push(u)
                    });

                    this.success_search_user = "Usuarios encontrados con el valor: " + this.search_user_lastName
                }else{
                    this.error_search_user = "No se encontraron resultados."
                }
            })

        }else{
            this.error_search_user = "Teclea el apellido para realizar la busqueda."
        }

        this.show_spinner_search = false
        this.search_user_lastName = ""
    },
    searchUserEmail: async function(){
        this.page = 1
        this.show_spinner_search = true
        this.success_search_user = ""
        this.error_search_user = ""
        console.log('whis user emial,,,,', this.search_user_email)

        if(this.search_user_email!=""){

            await db.collection('users')
            .where("email", "==", this.search_user_email)
            .get()
            .then((querySnapshot) => {

                if(querySnapshot.empty==false){
                    this.users = []
                
                    querySnapshot.forEach((doc) => {

                        var package_name = ""
                        var suscription_date = ""

                        if(doc.data().packages){
                            var last_packages_position = doc.data().packages.length

                            package_name = doc.data().packages[last_packages_position -1].package_name
                            var start = doc.data().packages[last_packages_position -1].package_start.toDate()
                            var end = doc.data().packages[last_packages_position -1].package_end.toDate()
                            
                            var day = "0" +start.getDate()
                            var month = "0" + (start.getMonth()+1)
                            var year = start.getFullYear()
                            var hours = start.getHours()
                            var minutes = "0" + start.getMinutes()
                            var seconds = "0" + start.getSeconds()

                            var package_start = day.substr(-2) + "-" + month.substr(-2) + "-" + year + " " + hours + ':' + minutes.substr(-2) + ':' + seconds.substr(-2);

                            day = "0" +end.getDate()
                            month = "0" + (end.getMonth()+1)
                            year = end.getFullYear()
                            hours = end.getHours()
                            minutes = "0" + end.getMinutes()
                            seconds = "0" + end.getSeconds()

                            var package_end = day.substr(-2) + "-" + month.substr(-2) + "-" + year + " " + hours + ':' + minutes.substr(-2) + ':' + seconds.substr(-2);
                            
                            suscription_date = "Del: " + package_start + " hasta: " + package_end
                        }

                        var u = {
                            uid: doc.data().uid,
                            name: doc.data().name,
                            lastName: doc.data().lastName,
                            email: doc.data().email,
                            package_name: package_name,
                            suscription_date: suscription_date,
                            regeristeredAt: doc.data().regeristeredAt,
                            phone: doc.data().phone
                        }

                        this.users.push(u)
                    });

                    this.success_search_user = "Usuarios encontrados con el valor: " + this.search_user_lastName
                }else{
                    this.error_search_user = "No se encontraron resultados."
                }
            })

        }else{
            this.error_search_user = "Teclea el apellido para realizar la busqueda."
        }

        this.show_spinner_search = false
        this.search_user_lastName = ""
    },
    errorName(){
        if(this.name!=""){
            this.error_name = ""
            return true
        }else{
            this.error_name = "El nombre no puede estar vacío."
            return false
        }
    },
    errorLastName(){
        if(this.lastName!=""){
            this.error_lastName = ""
            return true
        }else{
            this.error_lastName = "El apellido no puede estar vacío."
            return false
        }
    },
    showAddModal(){
        this.success_search_user = ""
        this.error_search_user = ""
        this.error_form = ""
        this.success_form = ""
        this.dialog = true
    },
    showEditModal(i){
        this.success_search_user = ""
        this.error_search_user = ""
        this.error_edit_form = ""
        this.success_edit_form = ""
        this.error_name = ""
        this.error_lastName = ""
        this.error_email = ""
        this.name = this.users[i].name
        this.lastName = this.users[i].lastName
        this.email = this.users[i].email
        this.uid = this.users[i].uid
        this.dialog_edit = true
    },
    showDeleteModal(i){
        this.success_search_user = ""
        this.error_search_user = ""
        this.error_delete_form = ""
        this.success_delete_form = ""
        this.name_delete = this.users[i].name
        this.uid_delete = this.users[i].uid
        this.dialog_delete = true
    },
    seeUserPackages: async function(i){
        this.success_search_user = ""
        this.error_search_user = ""
        this.package_user_name = this.users[i].name + " " + this.users[i].lastName
        this.position_user = i
        this.see_packages = []
        this.error_see_form = ""
        this.success_see_form = ""
        this.package_name = "*"
        this.uid_see = this.users[i].uid
        this.edit_package = false
        this.show_package = false
        this.select_package = '*'

        await db.collection('users').doc(this.users[i].uid).get().then(doc =>{

            if(doc.data().packages){

                for (var j = 0 ; j < doc.data().packages.length; j++) {

                    if(this.see_packages.length<5){
                        var start = doc.data().packages[j].package_start.toDate()
                        var end = doc.data().packages[j].package_end.toDate()

                        var day = "0" +start.getDate()
                        var month = "0" + (start.getMonth()+1)
                        var year = start.getFullYear()
                        var hours = start.getHours()
                        var minutes = "0" + start.getMinutes()
                        var seconds = "0" + start.getSeconds()

                        var package_start = day.substr(-2) + "-" + month.substr(-2) + "-" + year + " " + hours + ':' + minutes.substr(-2) + ':' + seconds.substr(-2);

                        day = "0" +end.getDate()
                        month = "0" + (end.getMonth()+1)
                        year = end.getFullYear()
                        hours = end.getHours()
                        minutes = "0" + end.getMinutes()
                        seconds = "0" + end.getSeconds()

                        var package_end = day.substr(-2) + "-" + month.substr(-2) + "-" + year + " " + hours + ':' + minutes.substr(-2) + ':' + seconds.substr(-2);

                        var p = {
                            name: doc.data().packages[j].package_name,
                            suscription_date: "Del: " + package_start + " hasta: " + package_end,
                            price: doc.data().packages[j].package_price
                        }

                        this.see_packages.push(p)
                    }else{
                        break
                    }
                }
            }
        }) 

        this.dialog_see = true
    },
    refreshUserPackages: async function(i){
        this.see_packages = []

        await db.collection('users').doc(this.users[i].uid).get().then(doc =>{

            if(doc.data().packages){

                for (var j = 0 ; j < doc.data().packages.length; j++) {

                    if(this.see_packages.length<5){
                        var start = doc.data().packages[j].package_start.toDate()
                        var end = doc.data().packages[j].package_end.toDate()

                        var day = "0" +start.getDate()
                        var month = "0" + (start.getMonth()+1)
                        var year = start.getFullYear()
                        var hours = start.getHours()
                        var minutes = "0" + start.getMinutes()
                        var seconds = "0" + start.getSeconds()

                        var package_start = day.substr(-2) + "-" + month.substr(-2) + "-" + year + " " + hours + ':' + minutes.substr(-2) + ':' + seconds.substr(-2);

                        day = "0" +end.getDate()
                        month = "0" + (end.getMonth()+1)
                        year = end.getFullYear()
                        hours = end.getHours()
                        minutes = "0" + end.getMinutes()
                        seconds = "0" + end.getSeconds()

                        var package_end = day.substr(-2) + "-" + month.substr(-2) + "-" + year + " " + hours + ':' + minutes.substr(-2) + ':' + seconds.substr(-2);

                        var p = {
                            name: doc.data().packages[j].package_name,
                            suscription_date: "Del: " + package_start + " hasta: " + package_end,
                            price: doc.data().packages[j].package_price
                        }

                        this.see_packages.push(p)
                    }else{
                        break
                    }
                }
            }
        }) 
    },
    addRow(index){
        if(this.rows[index+1] !== undefined){
            setTimeout(() => {
                let input = this.$refs.table_ref[index+1];
                input.focus();
            },200);
        }else{
            this.rows.push({name: '', lastName: '', email: '', package: '*'});
            setTimeout(() => {
                let index = this.rows.length - 1;
                let input = this.$refs.table_ref[index];
                input.focus();
            },200);
            this.count_index = this.count_index + 1;
        }
    },
    removeRow: function(row) {
        if(!(this.rows.length-1)<1){
            this.rows.splice(row, 1);
            this.count_index = this.count_index - 1;
        }
    },
    validEmail: function (email) {
        var re =/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/
        return re.test(email)
    },
    editPackage(){
        this.select_package = this.see_packages[0].name
        this.edit_package = true
        this.show_package = true
    },
    changePage(page,action){
        if(page > 0) {
            if(action=="add"){
                var lastName_position = this.users.length-1
                var bottom = this.users[lastName_position].regeristeredAt
                
                if(!this.array_regeristeredAt[page-1]){
                    var r = {
                        date: bottom
                    }
                    this.array_regeristeredAt.push(r)
                }
                
                this.getData(bottom,page)
            }else{
                var bottom = this.array_regeristeredAt[page-1].date
                this.getData(bottom,page)
            }
        }
    },
    toTimestamp(strDate){
        var datum = Date.parse(strDate)

        var r = {
            date: datum
        }
        this.array_regeristeredAt.push(r)

        return datum/1000
    },
    getData: async function(bottom,page){
        this.success_search_user = ""
        this.error_search_user = ""
        if(page > 0) {
            
            var has_elements = false

            await db.collection("users").where("role", "==", "customer").where("is_active", "==", "1").orderBy("regeristeredAt").startAfter(bottom).limit(10)
            .get()
            .then((querySnapshot) => {

                if(querySnapshot.empty==false){
                    this.users = []
                    has_elements = true
                
                    querySnapshot.forEach((doc) => {

                        var package_name = ""
                        var suscription_date = ""

                        if(doc.data().packages){
                            var last_packages_position = doc.data().packages.length

                            package_name = doc.data().packages[last_packages_position -1].package_name
                            var start = doc.data().packages[last_packages_position -1].package_start.toDate()
                            var end = doc.data().packages[last_packages_position -1].package_end.toDate()
                            
                            var day = "0" +start.getDate()
                            var month = "0" + (start.getMonth()+1)
                            var year = start.getFullYear()
                            var hours = start.getHours()
                            var minutes = "0" + start.getMinutes()
                            var seconds = "0" + start.getSeconds()

                            var package_start = day.substr(-2) + "-" + month.substr(-2) + "-" + year + " " + hours + ':' + minutes.substr(-2) + ':' + seconds.substr(-2);

                            day = "0" +end.getDate()
                            month = "0" + (end.getMonth()+1)
                            year = end.getFullYear()
                            hours = end.getHours()
                            minutes = "0" + end.getMinutes()
                            seconds = "0" + end.getSeconds()

                            var package_end = day.substr(-2) + "-" + month.substr(-2) + "-" + year + " " + hours + ':' + minutes.substr(-2) + ':' + seconds.substr(-2);
                            
                            suscription_date = "Del: " + package_start + " hasta: " + package_end
                        }

                        var u = {
                            uid: doc.data().uid,
                            name: doc.data().name,
                            lastName: doc.data().lastName,
                            email: doc.data().email,
                            package_name: package_name,
                            suscription_date: suscription_date,
                            regeristeredAt: doc.data().regeristeredAt,
                            phone: doc.data().phone
                        }

                        this.users.push(u)
                    });
                }

            })
            .catch((error) => {
                console.log("Error getting documents: ", error);
            });

            if(has_elements){
                this.page = page
            }
        }
    }
  },
  created(){
    this.getData(this.toTimestamp("01/01/2021 12:13:29"),1)
  }
};
</script>
<style>

#backGND {
  background-image: url("../assets/back.png");
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center center;
}

.register-modal{
  outline: none; border-bottom: 2px solid black; width: 100%; color: black; text-align: center;
}

.error_message{
  font-weight: 900;
  font-size: 1.1em;
  color: red;
  text-align-last: center;
}

.success_message{
  font-weight: 900;
  font-size: 1.1em;
  color: green;
  text-align-last: center;
}

</style>


// WEBPACK FOOTER //
// src/components/user_admin.vue